module.exports = __webpack_public_path__ + "static/media/pipes_prince.a9a5fdf0.jpg";